// The values AWS CodePipeline reports for a pipeline's most recent execution.
// Free text on the CodePipeline type, but a closed set in practice, so the
// filter offers a select rather than a text box the operator must spell right.
//
// {value,label} objects, not bare strings: FormikSelect renders nothing from a
// plain string array. Verified in the browser, not just in a test.
export const EXECUTION_STATUS_OPTIONS = [
    {value: 'Succeeded', label: 'Succeeded'},
    {value: 'Failed', label: 'Failed'},
    {value: 'InProgress', label: 'In Progress'},
    {value: 'Stopped', label: 'Stopped'},
    {value: 'Stopping', label: 'Stopping'},
    {value: 'Superseded', label: 'Superseded'},
];

